import { render, staticRenderFns } from "./pageResultItem.vue?vue&type=template&id=efb08796&"
import script from "./pageResultItem.vue?vue&type=script&lang=js&"
export * from "./pageResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb08796')) {
      api.createRecord('efb08796', component.options)
    } else {
      api.reload('efb08796', component.options)
    }
    module.hot.accept("./pageResultItem.vue?vue&type=template&id=efb08796&", function () {
      api.rerender('efb08796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Search/pageResultItem.vue"
export default component.exports